import { render, staticRenderFns } from "./CourseSchedule.vue?vue&type=template&id=4d603458&scoped=true&"
import script from "./CourseSchedule.vue?vue&type=script&lang=js&"
export * from "./CourseSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CourseSchedule.vue?vue&type=style&index=0&id=4d603458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d603458",
  null
  
)

export default component.exports